import { LoadedWorkflowV1 } from '../migrateTo1';

export type LoadedWorkflowV2 = LoadedWorkflowV1 & {
  workcellInstruments: Record<
    string,
    {
      bench: string;
      driverName: string;
      driverVersion: string;
      capacity: number;
      config: {
        [key: string]: any;
      };
      type?: string;
      has_special_parking_bay?: boolean;
      is_slotless_container?: boolean;
      mappings?: string[];
      simulate?: boolean;
    }
  >;
};

export const _migrateTo2 = (
  workflowConfig: LoadedWorkflowV1
): LoadedWorkflowV2 => {
  return {
    ...workflowConfig,
    workcellInstruments: {},
  };
};
